import {fileColorMap, fileIconMap} from "../../contentUtils";
import type {ChecklistFileItem, ChecklistRelatedItem} from "../../types";
import {getFileDownloadInfo} from "../fileDownload";
import IconDownload from "../../../../assets/download.svg?react";
import styles from "../checklist-documents-list.module.css";
import {bffApi} from "../../../chat/bffApi";
import {metricUuid, newMetricEvent} from "../../../chat/metrics";

export const FileRefRow = ({
    fileItem,
    relatedItem,
}: {
    fileItem: ChecklistFileItem;
    relatedItem?: ChecklistRelatedItem;
}) => {
    const [trackInteraction] = bffApi.endpoints.trackInteraction.useMutation();
    const info = getFileDownloadInfo(fileItem, relatedItem);
    if (!info) return null;

    const Icon = fileIconMap[info.resourceTypeId];
    const color = fileColorMap[info.resourceTypeId];

    return (
        <a
            href={info.href}
            download={info.downloadName}
            className={styles.fileRow}
            data-pw="file-download"
            onClick={() => {
                void trackInteraction({
                    ...newMetricEvent(),
                    action: "file_download_requested",
                    subjectId: metricUuid(fileItem.id),
                    source: "checklist",
                    format: "unknown",
                });
            }}
        >
            <IconDownload aria-hidden="true" className={styles.downloadIcon} />
            {Icon && (
                <Icon
                    aria-hidden="true"
                    className={styles.fileIcon}
                    style={color ? {color} : undefined}
                />
            )}
            <span className={styles.fileRowLabel}>{fileItem.subname}</span>
        </a>
    );
};
